import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
  code: Yup.string()
    .required()
    .length(6)
    .matches(/^[0-9]+$/, 'Authentication code must include only numbers')
    .label('Authentication code'),
});
